import { utils } from '@sfaas/util';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getPlants: () => {
		return client
			.get(`${BASE_URL}/cc/v1/plant`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getLogTypes: ({ plantCd, commCdType }) => {
		let url = `${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=` + commCdType;
		return client
			.get(url)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getErrorLogList: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';
		queryStr = utils.$sf_objectToQueryString({
			plantCd: searchParams.plantCd,
			startDt: searchParams.startDt,
			endDt: searchParams.endDt,
			logType: searchParams.logType,
			procId: searchParams.procId,
			message: searchParams.message,
			chkFlag: searchParams.chkFlag,
			//
			currentPage,
			pageUnit
		});
		let url = `${BASE_URL}/log/v1/plants/${searchParams.plantCd}/errorLogs` + queryStr;
		return client
			.get(url)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	setConfirm: ({ plantCd, payload }) => {
		let url = `${BASE_URL}/log/v1/status/2/plants/${plantCd}/errorLogs`;
		return client
			.post(url, payload)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
